import { Component, OnInit } from '@angular/core';
import { HomepagelocalService } from './countryhome.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { Constants } from 'src/app/shared/utilities/contants';
import { CommonCountryHeroComponent } from 'src/app/shared/components/countryHero/hero.component';
import { LocalTrustedWaySectionComponent } from './trusted-way-section/trusted-way-section.component';
import { BenefitsSectionComponent } from './benefits/benefits.component';
import { VideoSectionComponent } from './video-section/video.component';
import { FormSectionComponent } from './form-container/form-container.component';
import { FeaturesSectionComponent } from './features/features.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { CommonModule } from '@angular/common';
import { CustomGetstartedComponent } from './getStarted/getstarted.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';
@Component({
  selector: 'app-countryhome',
  templateUrl: './countryhome.component.html',
  styleUrls: ['./countryhome.component.scss'],
  imports: [
    CommonModule,
    CommonCountryHeroComponent,
    LocalTrustedWaySectionComponent,
    BenefitsSectionComponent,
    VideoSectionComponent,
    FormSectionComponent,
    FeaturesSectionComponent,
    CommonSubProductsWhitePaperComponent,
    CustomGetstartedComponent
  ],
})
export class CountryHomeComponent implements OnInit {
  heroHeader: any;
  logosData: any;
  countryName: string = '';
  newsList: any;
  getStartedData?: any;
  pageData: any;
  whitePaperData: any;
  constructor(
    private localHomePageService: HomepagelocalService,
    private route: ActivatedRoute,
    private posthogService: PosthogService
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data['seo'][0].fields;
    this.pageData = this.route.snapshot.data['seo'][0].fields;
    if (data) {
      this.pageData = data;
      const heroData = data?.heroContentPanel?.fields;
      this.whitePaperData = this.pageData?.whitepaperAndReportsArticle?.fields;
      const getStartedData = this.pageData?.getStartedContentPanel?.fields;
      if (heroData != null) {
        this.heroHeader = {
          tagName: heroData?.tags?.[0]?.fields?.tagText,
          tagIcon: heroData?.tags?.[0]?.fields?.icon?.fields?.file?.url,
          header: heroData?.title,
          image: heroData?.image[0].fields,
          paragraph: heroData?.content,
          button1: {
            text: heroData?.buttons?.[0]?.fields?.buttonText,
            url: heroData?.buttons?.[0]?.fields?.redirectLink,
            target: heroData?.buttons?.[0]?.fields?.actionType,
          },
          button2: {
            text: heroData?.buttons?.[1]?.fields?.buttonText,
            url: heroData?.buttons?.[1]?.fields?.redirectLink,
            target: heroData?.buttons?.[1]?.fields?.actionType,
          },
        };
      }
      if (getStartedData != null) {
        this.getStartedData = {
          header: getStartedData?.title,
          button1: {
            url: getStartedData?.buttons[0].fields.redirectLink,
            text: getStartedData?.buttons[0].fields.buttonText,
            target: getStartedData?.buttons[0].fields.actionType,
          },
          button2: {
            url: getStartedData?.buttons[1].fields.redirectLink,
            text: getStartedData?.buttons[1].fields.buttonText,
            target: getStartedData?.buttons[1].fields.actionType,
            fileUrl: getStartedData?.buttons[1].fields.icon?.fields?.file?.url,
          },
        };
      }
    }
    this.posthogService.capturePageViewEvent('southafrica');
  }
}
